/** Agents with a live detail page, keyed by agent name. */
export const AGENT_PAGES: Record<string, string> = {
    Vexo: "/ai-team/vexo",
    Luma: "/ai-team/luma",
    Nova: "/ai-team/nova",
    Sketch: "/ai-team/sketch",
    Flux: "/ai-team/flux",
    Koda: "/ai-team/koda",
    Loop: "/ai-team/loop",
    Quill: "/ai-team/quill",
    Buzz: "/ai-team/buzz",
};
